import React from 'react';
import 'animate.css';
import { Layout, Typography } from 'antd';
import AixueFooter from '@/components/AixueFooter/index';
import Screen1 from './Screen1';
import Screen2 from './Screen2';
import Screen3 from './Screen3';
import styles from './index.module.scss';

const { Header, Content } = Layout;
const { Title, Paragraph } = Typography;

export default function AixuePhonics() {
  return (
    <div className={styles.container} data-scroll-root="aixue-phonics">
      <Screen1 />
      <Screen2 />
      <Screen3 />
      <div className={styles['footer-snap']}>
        <AixueFooter />
      </div>
    </div>
  );
}
